var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { StatusPermission } from '../../../enum';
import { Table, TableContainer } from '../../common';
import { useFormlessContext } from '../../hooks';
import { QuickInputDialog } from '../common/quickInputDialog';
import { LocationTableEntryMode, WizardStep } from '../constants';
import { useEffectiveCapacityPermission, useEffectiveQueueLocations, useIsPlanLocked, useWizardParams } from '../selectors';
import { LocationTableBody } from './body';
import { STICKIES } from './constants';
import { LocationTableHeader } from './header';
export { StyledCountryRow, StyledLocationTypeRow } from './styles';
export var LocationTable = memo(function (_a) {
  var _b;
  var _c = _a.min,
    min = _c === void 0 ? 1 : _c,
    _d = _a.max,
    max = _d === void 0 ? 99999 : _d,
    name = _a.name,
    _e = _a.enableQuickInput,
    enableQuickInput = _e === void 0 ? true : _e,
    entryModeField = _a.entryModeField,
    suffix = _a.suffix,
    addColumnsProp = _a.addColumns,
    decimal = _a.decimal,
    isAbsoluteDisabled = _a.isAbsoluteDisabled,
    _f = _a.absoluteDecimal,
    absoluteDecimal = _f === void 0 ? 0 : _f,
    extraColumns = _a.extraColumns,
    usePeriodLabels = _a.usePeriodLabels,
    bodyProps = __rest(_a, ["min", "max", "name", "enableQuickInput", "entryModeField", "suffix", "addColumns", "decimal", "isAbsoluteDisabled", "absoluteDecimal", "extraColumns", "usePeriodLabels"]);
  var step = useWizardParams().step;
  var locations = useEffectiveQueueLocations();
  var hasLocations = !!locations.length;
  var hideSticky = !hasLocations && !enableQuickInput && !entryModeField;
  var stickySizes = hideSticky ? undefined : STICKIES;
  if (hasLocations && !hideSticky) {
    stickySizes = ['16rem'];
  }
  var capacityPermission = useEffectiveCapacityPermission();
  var isPlanLocked = useIsPlanLocked();
  var isDisabled = capacityPermission !== StatusPermission.Edit || isPlanLocked;
  var addColumns = step === WizardStep.Review ? addColumnsProp : [];
  var _g = useState(false),
    quickInputOpen = _g[0],
    setQuickInputOpen = _g[1];
  var control = ((_b = useFormlessContext()) !== null && _b !== void 0 ? _b : {}).control;
  var entryMode = useWatch({
    name: entryModeField !== null && entryModeField !== void 0 ? entryModeField : '',
    control: control
  });
  // Derive effective input constraints from entry mode
  var isPercentageMode = entryModeField ? entryMode !== LocationTableEntryMode.Absolute : false;
  var bodyConfig = isPercentageMode ? {
    min: 0,
    max: 100,
    suffix: '%'
  } : {
    min: min,
    max: max,
    suffix: suffix
  };
  var displayDecimal = entryMode === LocationTableEntryMode.Absolute ? absoluteDecimal : decimal;
  return _jsxs(_Fragment, {
    children: [_jsx(TableContainer, __assign({
      topScroll: hasLocations
    }, {
      children: _jsxs(Table, {
        children: [_jsx(LocationTableHeader, {
          addColumns: addColumns,
          stickySizes: stickySizes,
          onQuickInputClick: enableQuickInput ? function () {
            return setQuickInputOpen(true);
          } : undefined,
          disabled: isDisabled,
          name: name,
          entryModeField: entryModeField,
          decimal: decimal,
          isAbsoluteDisabled: isAbsoluteDisabled,
          extraColumns: extraColumns,
          usePeriodLabels: usePeriodLabels
        }), _jsx(LocationTableBody, __assign({}, bodyProps, {
          name: name,
          decimal: displayDecimal,
          extraColumns: extraColumns
        }, bodyConfig, {
          disabled: isDisabled,
          addColumns: addColumns,
          hideSticky: hideSticky
        }))]
      })
    })), enableQuickInput && _jsx(QuickInputDialog, {
      open: quickInputOpen,
      onClose: function () {
        return setQuickInputOpen(false);
      },
      name: name,
      min: min,
      max: max,
      suffix: suffix,
      decimal: displayDecimal
    })]
  });
});